export const MAP_INITIALIZE = 'passport/MAP_INITIALIZE';
export const MAP_INITIALIZE_SUCCESS = 'passport/MAP_INITIALIZE_SUCCESS';

export const MAP_CREATE = 'passport/MAP_CREATE';
export const MAP_CREATE_SUCCESS = 'passport/MAP_CREATE_SUCCESS';

export const MAP_LOADED = 'passport/MAP_LOADED';

export const MAP_DESTROY = 'passport/MAP_DESTROY';
export const MAP_RESIZE = 'passport/MAP_RESIZE';

export const MAP_CENTER = 'passport/MAP_CENTER';

export const MAP_ZOOM_LEVEL = 'passport/MAP_ZOOM_LEVEL';
export const MAP_ZOOM_LEVEL_SUCCESS = 'passport/MAP_ZOOM_LEVEL_SUCCESS';

export const MAP_LISTEN_ZOOM_EVENT = 'passport/MAP_LISTEN_ZOOM_EVENT';
export const MAP_LISTEN_CLICK_EVENT = 'passport/MAP_LISTEN_CLICK_EVENT';

export const MAP_LISTEN_DRAG_START_EVENT = 'passport/MAP_LISTEN_DRAG_START_EVENT';
export const MAP_LISTEN_DRAG_END_EVENT = 'passport/MAP_LISTEN_DRAG_END_EVENT';

export const MAP_LISTEN_IDLE_EVENT = 'passport/MAP_LISTEN_IDLE_EVENT';

export const SET_LOCATION = 'passport/SET_LOCATION';
export const SET_ACTUAL_LOCATION = 'passport/SET_ACTUAL_LOCATION';
export const SET_MARKER_LOCATION = 'passport/SET_MARKER_LOCATION';
export const SET_MARKER_POSITION = 'passport/SET_MARKER_POSITION';
export const SET_TRAVEL_LOCATION = 'passport/SET_TRAVEL_LOCATION';
export const SET_TRAVEL_LOCATION_SUCCESS = 'passport/SET_TRAVEL_LOCATION_SUCCESS';
export const SET_TRAVEL_LOCATION_OPTIMISTIC = 'passport/SET_TRAVEL_LOCATION_OPTIMISTIC';
export const SET_CURRENT_LOCATION = 'passport/SET_CURRENT_LOCATION';
export const RESET_LOCATION = 'passport/RESET_LOCATION';
export const RESET_LOCATION_SUCCESS = 'passport/RESET_LOCATION_SUCCESS';

export const ADD_RECENT_LOCATION = 'passport/ADD_RECENT_LOCATION';

export const RETRIEVE_PLACE_DETAILS = 'passport/RETRIEVE_PLACE_DETAILS';
export const RETRIEVE_PLACE_DETAILS_SUCCESS = 'passport/RETRIEVE_PLACE_DETAILS_SUCCESS';

export const FETCH_POPULAR_LOCATIONS = 'passport/FETCH_POPULAR_LOCATIONS';
export const FETCH_POPULAR_LOCATIONS_SUCCESS = 'passport/FETCH_POPULAR_LOCATIONS_SUCCESS';

export const GET_SEARCH_RESULTS = 'passport/GET_SEARCH_RESULTS';
export const GET_SEARCH_RESULTS_SUCCESS = 'passport/GET_SEARCH_RESULTS_SUCCESS';

export const SHOW_LOCATION_INFO = 'passport/SHOW_LOCATION_INFO';
export const HIDE_LOCATION_INFO = 'passport/HIDE_LOCATION_INFO';

export const REDIRECT = 'passport/REDIRECT';

export const GET_ACTUAL_LOCATION_INFO = 'passport/GET_ACTUAL_LOCATION_INFO';
export const GET_ACTUAL_LOCATION_INFO_SUCCESS = 'passport/GET_ACTUAL_LOCATION_INFO_SUCCESS';
